// ============================================================================
// CARTESIAN TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'cartesian-tree',
  name: 'Cartesian Tree',
  category: 'Data Structures',
  complexity: {
    time: 'O(N) construction',
    space: 'O(N)'
  },
  description: 'A binary tree derived from a sequence where the root is the minimum element, and left and right subtrees are recursively constructed from sub-sequences. Useful for range minimum queries and treap construction.'
};
